(function() {
    'use strict';
    var controllerId = 'locationProductsCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modal', '$timeout', '$cookies', '$routeParams', locationProductsCtrl]);

    function locationProductsCtrl(common, datacontext, $scope, $modal, $timeout, $cookies, $routeParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.locations = [];
        vm.title = 'Location product partial';
        vm.product_id = $scope.product_id;
        vm.master_inv_pid = $scope.master_inv_pid;
        vm.location_product_updated = 0;
        vm.temp_loc_prod_id = [];
        vm.temp_location_id = [];
        vm.temp_storeproduct = [];
        vm.location_update = 0;
        vm.location_create = 0;
        vm.last_location_type = $cookies.get('last_location_type');
        vm.last_location_type_id = $cookies.get('last_location_type_id');
        vm.last_location_number = $cookies.get('last_location_number');
        console.log(vm);
        activate();
        function activate() {
            var promises = [get_location_types(),
                get_location_products()];
            common.activateController(promises, controllerId)
                .then(function() {
                  //  log('Activated Location List View');
                });
        }


        function get_location_types() {
            return datacontext.get_location_types({warehouse_id:$scope.warehouse_id,isActive:1}).then(function (httpResult) {
                vm.location_types = httpResult.data.data;
            });
        }

        function get_location_products() {
            return datacontext.get_location_products({product_id:$scope.product_id}).then(function (httpResult) {
                vm.location_products = httpResult.data.data;

                if($routeParams.shelf){
                    $scope.shelf = $routeParams.shelf;
                    $scope.shelf_values = $scope.shelf.split('-');
                    $scope.location_type = $scope.shelf_values[0];
                    $scope.location_num = $scope.shelf_values[1];

                    vm.location_products.push({
                        location_product_updated:0,
                        location_type_id:27,
                        location_number:parseInt($scope.location_num),
                        warehouse_id:0,
                        product_id: $scope.product_id
                    });
                }

                $scope.on_hand = 0;
                $scope.on_order = 0;
                $scope.sales_last_10_days = 0;
                if($scope.master_inv_pid > 0){
                  return datacontext.get_on_hand({product_id:$scope.master_inv_pid}).then(function (httpResult) {
                      $scope.master_on_hand = httpResult.data.data;
                  });
                }
                angular.forEach(vm.location_products, function(item) {
                    $scope.on_hand = $scope.on_hand + item.location_on_hand;
                    $scope.sales_last_10_days = item.sales_last_10_days;
                    $scope.on_order = item.on_order;
                });

                if (vm.location_products.length === 0) {
                    // Auto add empty location
                    vm.location_products = [
                        { location_type_id: 1, location_num: 0, product_id: $scope.product_id }
                    ];
                }
            });
        }
        $scope.lookup = function (locObj, idx){
          console.log(locObj);
          var location_type_id = locObj.location_type_id;
          $scope.pid_print = {product_id: $scope.product_id,
                              location_type_id: location_type_id};

          var modalInstance = $modal.open({
              templateUrl: '/app/locationproducts/partials/lookup_loc.html',
              controller: 'lookupLocCtrl',
              resolve: {
                  pid_print: function () {
                      return $scope.pid_print;
                  }
              }
          }).result.then(function(result){
                  //$scope.tracking_number = result;
              });

          vm.cancel = function () {
              modalInstance.dismiss('cancel');
          };

        };
        $scope.lookup_his = function (locObj, idx){
          console.log(locObj);
          var location_type_id = locObj.location_type_id;
          $scope.pid_print = {product_id: $scope.product_id,
                              location_type_id: location_type_id,
                              location_number: locObj.location_number
                            };

          var modalInstance = $modal.open({
              templateUrl: '/app/locationproducts/partials/lookup_loc_history.html',
              controller: 'lookupLocHistoryCtrl',
              resolve: {
                  pid_print: function () {
                      return $scope.pid_print;
                  }
              }
          }).result.then(function(result){
                  //$scope.tracking_number = result;
              });

          vm.cancel = function () {
              modalInstance.dismiss('cancel');
          };

        };

        //  Update Locations
        $scope.submit_locations_for_update = function (locObj) {
            angular.forEach(vm.location_products, function (loc) {
                if (angular.isDefined(loc.loc_prod_id)) {
                    datacontext.update_location_product(loc).success(function (httpResult) {
                    	vm.location_update = 1;
                      log('Updated Location');
                    });
                } else {
                    loc.product_id = vm.product_id;
                    if (!(angular.isDefined(loc.location_on_hand))) {
                    	log('Location On-Hand required.');
                    }else{
                    	datacontext.create_location_product(loc).success(function (httpResult) {
                    		vm.location_create = 1;
                        log('Created Location');
                      });
                    }

                }
            });

            get_location_products();
        };
        // todo: Verify Unique SKU

        //  Location Number Change
        $scope.verify_location_number = function (locObj, idx) {
            // lookup location number

            datacontext.get_open_location(locObj.location_type_id).then(function (httpResult) {
                vm.location_products[idx].location_number = httpResult.data.data;
                //log('location updated');
            });
        };

        $scope.update_location_type = function (locObj, idx) {
            // lookup location number
            datacontext.get_open_location(locObj.location_type_id, vm.product_id).then(function (httpResult) {
                vm.location_products[idx] = httpResult.data.data[0];

            });
        };

        $scope.update_location_number = function (locObj, idx) {
            if(angular.isUndefined(vm.temp_loc_prod_id[idx])){
                    vm.temp_loc_prod_id[idx] = locObj.loc_prod_id;
                    vm.temp_location_id[idx] = locObj.location_id;
            }
            vm.temp_storeproduct[idx] = locObj;
            // lookup location Number
            datacontext.get_location_id(
                locObj.location_type_id,
                locObj.location_number).then(function (httpResult) {
                    if (httpResult.data.success === true) {
                        vm.location_products[idx] = httpResult.data.data[0];
                        vm.location_products[idx].location_on_hand = vm.temp_storeproduct[idx].location_on_hand;
                    } else {
                        //log('location error');
                    }
            });
        };

        // update location_product
        $scope.update_location_product = function (locObj, idx, old_location_number) {
             var getLogFn = common.logger.getLogFn;
             var log = getLogFn(controllerId);
             var error = getLogFn(controllerId,'error');
             var lp = vm.location_products[idx];
            // Check if new product or old
            if (angular.isUndefined(lp.loc_prod_id) || lp.loc_prod_id === null) {
                locObj.product_id = $scope.product_id;
                datacontext.get_location_products(locObj).then(function (httpResult) {
                vm.data = httpResult.data.data.length;

                    if(vm.data){
                        error('Location already Exists');
                    }else{
                    	if( angular.isDefined(vm.temp_location_id[idx]) && angular.isDefined(vm.temp_loc_prod_id[idx]) ){

                    		if(angular.isDefined(locObj.location_type)){
                    			locObj.created_reason = "Moved from Location "+locObj.location_type+vm.temp_storeproduct[idx].location_number;
                        		locObj.tobedeleted_location = vm.temp_storeproduct[idx].location_id;
                    		}


                    	}

                    		if (!(angular.isDefined(locObj.location_on_hand))) {
	                        	log('Location On-Hand required.');
	                        }else{
                            datacontext.get_location_name(locObj.location_type_id).then(function (httpResult) {
                              console.log(httpResult);
                              $cookies.put('last_location_type', httpResult.data.TYPE);
                              $cookies.put('last_location_type_id', locObj.location_type_id);
                              $cookies.put('last_location_number', locObj.location_number);
                            });
                            console.log(locObj);
	                           datacontext.create_location_product(locObj).then(function (httpResult) {
		                            // update
		                            vm.location_products[idx].method = httpResult.data.data;
		                            $scope.$broadcast('refreshLocationProductsLog', 'refresh');

		                            $scope.product_on_hand = httpResult.data.ON_HAND;

		                            if( angular.isDefined(vm.temp_location_id[idx]) && angular.isDefined(vm.temp_loc_prod_id[idx]) ){
		                            	  datacontext.delete_location_temp(vm.temp_location_id[idx],vm.temp_loc_prod_id[idx],locObj.product_id,vm.temp_storeproduct[idx].location_number,vm.temp_storeproduct[idx].warehouse_id).then(function (httpResult) {
		                                	log('Location Number Updated');
		                                	vm.temp_loc_prod_id.length = 0;
	                                        vm.temp_location_id.length = 0;
	                                        //change product on hand
	                	                    $scope.product_on_hand = httpResult.data;
	                		                var myEl = angular.element( document.querySelector( '#product_on_hand' ) );
	                	                    myEl.text($scope.product_on_hand);

	                                        $scope.$broadcast('refreshLocationProductsLog', 'refresh');
		                                	get_location_products();
		                                });
		                            }else{
		                            	//change product on hand

		                            	log('Location Created');
		        		                var myEl = angular.element( document.querySelector( '#product_on_hand' ) );
		        	                    myEl.text($scope.product_on_hand);
		                            	// refresh list
			                            get_location_products();
		                            }

	                            });
	                        }
                        }
                });

            } else {
                if (locObj.location_on_hand == 0 && locObj.audit_check == 1) {
                	datacontext.delete_location(locObj).then(function (httpResult) {
	                    log('Location Deleted');
	                    vm.temp_loc_prod_id.length = 0;
	                    vm.temp_location_id.length = 0;
	                    //change product on hand
	                    $scope.product_on_hand = httpResult.data;
		                var myEl = angular.element( document.querySelector( '#product_on_hand' ) );
	                    myEl.text($scope.product_on_hand);

	                    $scope.$broadcast('refreshLocationProductsLog', 'refresh');
	                    get_location_products();
	                });
                }else{

                    datacontext.update_location_product(locObj).then(function (httpResult) {
	                    log('Location Updated');

	                    vm.temp_loc_prod_id.length = 0;
	                    vm.temp_location_id.length = 0;
	                    //change product on hand
	                    $scope.product_on_hand = httpResult.data;
		                var myEl = angular.element( document.querySelector( '#product_on_hand' ) );
	                    myEl.text($scope.product_on_hand);

	                    $scope.$broadcast('refreshLocationProductsLog', 'refresh');
	                    // refresh list
	                    get_location_products();
	                });
                }
            }
        };

        // Push Location Product
        $scope.add_location_product = function () {
            // Set new default location
            vm.location_products.push(
                {
                    location_product_updated:0,
                    loc_prod_id:0,
                    location_type_id:1,
                    location_num:0,
                    warehouse_id:0,
                    product_id: $scope.product_id
                });
        };

        $scope.add_location_product_last = function () {
            // Set new default location
            console.log("last_location_type_id:"+vm.last_location_type_id);
            console.log(vm.last_location_number);
            vm.location_products.push(
                {
                    location_product_updated:0,
                    location_type_id:parseInt(vm.last_location_type_id),
                    location_number:parseInt(vm.last_location_number),
                    warehouse_id:0,
                    product_id: $scope.product_id
                });
                console.log(vm.location_products);
        };


    }
})();

(function() {
    'use strict';
    var controllerId = 'lookupLocCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$modalInstance', 'pid_print', lookupLocCtrl]);

    function lookupLocCtrl(common, datacontext, $scope, $modalInstance, pid_print) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');
        var vm = this;
        console.log(pid_print);
        datacontext.get_open_location_v1(pid_print.location_type_id,pid_print.product_id).then(function (httpResult) {
          console.log(httpResult.data);
          $scope.location_available = httpResult.data.data;
            //log('location updated');
        });

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

    }
})();

(function() {
    'use strict';
    var controllerId = 'viewLocationsModalCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$modalInstance', 'locations', viewLocationsModalCtrl]);

    function viewLocationsModalCtrl(common, datacontext, $scope, $modalInstance, locations) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');
        var vm = this;
        console.log(locations);
        $scope.locations = locations;

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

    }
})();
(function() {
    'use strict';
    var controllerId = 'lookupLocHistoryCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$modalInstance', 'pid_print', lookupLocHistoryCtrl]);

    function lookupLocHistoryCtrl(common, datacontext, $scope, $modalInstance, pid_print) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');
        var vm = this;
        console.log(pid_print);
        datacontext.get_location_history(pid_print.location_type_id,pid_print.location_number,pid_print.product_id).then(function (httpResult) {
          console.log(httpResult.data);
          $scope.location_available = httpResult.data.data;
            //log('location updated');
        });

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

    }
})();
(function() {
    'use strict';
    var controllerId = 'locationProductsAuditCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$location','$routeParams', locationProductsAuditCtrl]);

    function locationProductsAuditCtrl(common, datacontext, $scope, $location, $routeParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.locations = [];
        vm.title = 'Location product partial';
        vm.product_id = $scope.product_id;

        $scope.default = {
            limit:10
        };

        vm.limit = 10;

        $scope.$on('refreshLocationProductsLog', function (event, data) {

            getLocationAudit();
        });

        $scope.filterLimit = function() {
            getLocationAudit();
        };

        activate();

        function activate() {
            var promises = [getLocationAudit()];
            common.activateController(promises, controllerId)
                .then(function() {
                    //  log('Activated Location List View');
                });
        }

        function getLocationAudit() {
            return datacontext.get_location_audit({
                product_id:vm.product_id,
                limit:$scope.default.limit}).then(function(httpResult) {
                    $scope.location_audit_log = httpResult.data.data;
            });
        }
    }
})();


(function() {
    'use strict';
    var controllerId = 'backstockRestockCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$location', 'ngTableParams', backstockRestockCtrl]);

    function backstockRestockCtrl(common, datacontext, $scope, $location, ngTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var vm = this;

        vm.location = [];
        vm.query = {
            order_by:"location_id",
            order_dir:"desc",
            page:1,
            limit:20
        };

        vm.query = $location.search();

        activate();

        function activate() {
            var promises = [get_backstockRestock()];
            common.activateController(promises, controllerId)
                .then(function() {
                    //  log('Activated Order List View');
                });
        }

        function get_backstockRestock() {
            $scope.tableParams = new ngTableParams({
                page: vm.query.page, // show first page
                count: 20,           // count per page
                sorting: {
                   product_id:'desc'},
                filter: vm.query
            }, {
                filterDelay: 750,    // default value (milliseconds)
                total: function () { return getData().length; }, // length of data
                getData: function($defer, params) {
                    // set page
                    vm.query.page = params.page;
                    vm.query.limit = vm.query.limit;

                    var sorting = params.sorting();
                    for(var key in sorting) {
                        vm.query.order_by = key;
                        vm.query.order_dir = sorting[key];
                    }
                    // ajax request to api
                    datacontext.get_backstockRestock(vm.query).then(function(httpResult) {
                        //$scope.search_filter = $location.absUrl() + '?' + $.param($scope.tableParams.$params);
                        var data = httpResult.data;
                        // update table params
                        params.total(data.total);
                        $scope.resultcount = data.total;
                        // set new data
                        $defer.resolve(data.data);
                    });

                }
            });
        }

    }
})();


(function() {
    'use strict';
    var controllerId = 'emptyLocationsCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$location', 'NgTableParams', emptyLocationsCtrl]);

    function emptyLocationsCtrl(common, datacontext, $scope, $location, NgTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;

        vm.location = [];
        vm.query = {
            order_by:"location_id",
            order_dir:"desc",
            is_empty:1,
            page:1,
            location_type_id:"0",
            limit:50
        };


        // selectively update
        vm.urlQuery  = $location.search();
        var url_used = 0;

        // loop and set url var
        for ( var i in vm.urlQuery ){
            if ( i !=='queryType') {
                vm.query[i] = vm.urlQuery[i];
            }
            url_used = 1;
        }

        $scope.$on('refresh_emptyLocationsCtrl', function (event, data) {
            activate();
        });

        function activate() {
            var promises = [
                get_empty_product_locations()
            ];
            common.activateController(promises, controllerId)
                .then(function() {
                    //  log('Activated Order List View');
                });
        }

        $scope.$watchCollection("vm.query",function (newValue, oldValue) {
        	if(vm.grid !== 0){
        		vm.grid = 0;
        		return "";
        	}
            for ( var i in newValue ) {
                if ( i !== 'page' && vm.grid == 0 && newValue[i] !== oldValue[i]) {
                    vm.startSearch ++;
                    vm.grid = 0;
                    get_empty_product_locations();
                }
            }
            vm.grid = 0;
        });
        function get_empty_product_locations() {

        	/*vm.query = {
                    order_by:"location_id",
                    order_dir:"desc",
                    is_empty:1,
                    page:1,
                    limit:10
                };*/

            vm.tableParams = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {

                    vm.query.page = params.page;
                    //vm.query.count = params.count;
                    vm.query.limit = 50;
                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }
                    // ajax request to api
                    return datacontext.get_product_location(vm.query).then(function (httpResult) {
                        params.total(httpResult.data.TOTAL);
                        vm.results_total = httpResult.data.TOTAL;

                        vm.remove_message = httpResult.data.TOTAL + " Items Found";

                        // set new data
                        vm.results = httpResult.data.data;
                        return httpResult.data.data;
                    });
                }
            });
        }

        // Push Location Product
        $scope.remove_location_product = function (data, idx) {



            var payload = {
                loc_prod_id:data.loc_prod_id,
                product_id:data.product_id,
                warehouse_id:data.warehouse_id
            };

            datacontext.delete_location_product(payload).then(function() {

                vm.results.splice(idx,1);
                vm.remove_message = 'LOCATION REMOVED: ' + data.location_name;
            });

        };

        $scope.removeFBALoc = function () {
            datacontext.remove_fba_locations().then(function() {
                vm.remove_message = 'FBA LOCATION REMOVED';
                get_empty_product_locations();
            });

        };


    }
})();

(function() {
    'use strict';
    var controllerId = 'locationHistoryCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$location', 'NgTableParams', locationHistoryCtrl]);

    function locationHistoryCtrl(common, datacontext, $scope, $location, NgTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        datacontext.get_location_types({warehouse_id:$scope.warehouse_id,isActive:1}).then(function (httpResult) {
            vm.location_types = httpResult.data.data;
        });
        // get audits
        $scope.getHistoryLogs = function (data) {
            var payload = {
                location_type_id:data.search_location_type,
                location_number:data.search,
                limit:50
            };

            datacontext.get_audit_history(payload).then(function(httpResult) {

              $scope.location_audit_log = httpResult.data.data;
            });

        };

    }
})();
(function() {
    'use strict';
    var controllerId = 'BlacklightsCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$location', 'NgTableParams', BlacklightsCtrl]);

    function BlacklightsCtrl(common, datacontext, $scope, $location, NgTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        $scope.$on('refresh_BlacklightsCtrl', function (event, data) {
        	activate();
        });

        function activate() {
            var promises = [
                get_backlights()

            ];
            common.activateController(promises, controllerId)
                .then(function() {
                    //  log('Activated Order List View');
                });
        }
        function get_backlights(){
          datacontext.get_backlights({isActive:1}).then(function (httpResult) {
              vm.backlight_items = httpResult.data.data;
              vm.backlight_items_cnt = httpResult.data.TOTAL;
          });
        }



    }
})();


(function() {
    'use strict';
    var controllerId = 'locationEmptyCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$location', 'NgTableParams', locationEmptyCtrl]);

    function locationEmptyCtrl(common, datacontext, $scope, $location, NgTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;

        vm.location = [];
        vm.query = {
            order_by:"location_name",
            order_dir:"ASC",
            is_empty:1,
            page:1,
            limit:50
        };


        // selectively update
        vm.urlQuery  = $location.search();
        var url_used = 0;

        // loop and set url var
        for ( var i in vm.urlQuery ){
            if ( i !=='queryType') {
                vm.query[i] = vm.urlQuery[i];
            }

            url_used = 1;
        }

        $scope.$on('refresh_locationEmptyCtrl', function (event, data) {
        	activate();
        });

        function activate() {
            var promises = [
                get_empty_product_locations()
            ];
            common.activateController(promises, controllerId)
                .then(function() {
                    //  log('Activated Order List View');
                });
        }


        function get_empty_product_locations() {

            vm.query = {
                    order_by:"location_name",
                    order_dir:"ASC",
                    is_empty:1,
                    page:1,
                    limit:50
                };
            vm.tableParams = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {

                    vm.query.page = params.page;
                    //vm.query.count = params.count;

                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }
                    // ajax request to api

                	return datacontext.get_empty_locations_details(vm.query).then(function (httpResult) {
                    params.total(httpResult.data.TOTAL);
                  	vm.results_total = httpResult.data.TOTAL;
                  	vm.results = httpResult.data.data;
                  	return httpResult.data.data;
                  });
                }
            });
        }

        // Push Location Product
        $scope.remove_location_product = function (data, idx) {

        	  var payload = {
                loc_prod_id:data.loc_prod_id,
                product_id:data.product_id,
                warehouse_id:data.warehouse_id
            };

            datacontext.delete_location_product(payload).then(function() {

                vm.results.splice(idx,1);
                vm.remove_message = 'LOCATION REMOVED: ' + data.location_name;
            });

        };
    }
})();

(function() {
    'use strict';
    var controllerId = 'bestSellersCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modal', '$location', 'NgTableParams', bestSellersCtrl]);

    function bestSellersCtrl(common, datacontext, $scope,$modal, $location, NgTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;

        vm.location = [];
        vm.query = {
            order_by:"location_name",
            order_dir:"ASC",
            is_empty:1,
            page:1,
            category_id:'0',
            missing_shelf:0,
            ex_fba:1,
            limit:50
        };


        // selectively update
        vm.urlQuery  = $location.search();
        var url_used = 0;

        // loop and set url var
        for ( var i in vm.urlQuery ){
            if ( i !=='queryType') {
                vm.query[i] = vm.urlQuery[i];
            }

            url_used = 1;
        }

        $scope.$on('refresh_bestSellersCtrl', function (event, data) {
        	activate();
        });

        function activate() {
            var promises = [
                get_product_categories(),
                get_best_seller()

            ];
            common.activateController(promises, controllerId)
                .then(function() {
                    //  log('Activated Order List View');
                });
        }
        $scope.$watchCollection("vm.query",function (newValue, oldValue) {
            for ( var i in newValue ) {
                if ( i !== 'page' && newValue[i] !== oldValue[i]) {
                    vm.startSearch ++;
                    get_best_seller();
                }
            }

        });

        function get_product_categories() {
            return datacontext.get_product_categories_v1({active_pid_count: 1}).then(function (httpResult) {
                $scope.product_categories = httpResult.data;

            });
        }
        function get_best_seller() {
          console.log(vm.query);
            // vm.query = {
            //         order_by:"location_name",
            //         order_dir:"ASC",
            //         is_empty:1,
            //         category_id:0,
            //         page:1,
            //         limit:50
            //     };
            vm.tableParams = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {

                    vm.query.page = params.page;
                    //vm.query.count = params.count;

                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }
                    // ajax request to api

                	return datacontext.get_best_seller(vm.query).then(function (httpResult) {
                    params.total(httpResult.data.TOTAL);
                  	vm.results_total = httpResult.data.TOTAL;
                  	vm.results = httpResult.data.data;
                  	return httpResult.data.data;
                  });
                }
            });
        }

        $scope.view_locations = function (pid) {
         datacontext.get_location_products({product_id:pid}).then(function (httpResult) {
              vm.location_products = httpResult.data.data;
              var modalInstance = $modal.open({
                  templateUrl: '/app/locations/partials/view_locations.html',
                  controller: 'viewLocationsModalCtrl',
                  resolve: {
                    locations: function () {
                          return vm.location_products;
                      }
                  }
              }).result.then(function (result) {

              });

              vm.cancel = function () {
                  modalInstance.dismiss('cancel');
              };
          });

        };

    }
})();
(function() {
    'use strict';
    var controllerId = 'locationAlertsCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$location', 'NgTableParams', locationAlertsCtrl]);

    function locationAlertsCtrl(common, datacontext, $scope, $location, NgTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;

        vm.location = [];
        vm.query = {
            order_by:"location_id",
            order_dir:"desc",
            is_empty:1,
            page:1,
            limit:50
        };

        // selectively update
        vm.urlQuery  = $location.search();
        var url_used = 0;

        // loop and set url var
        for ( var i in vm.urlQuery ){
            if ( i !=='queryType') {
                vm.query[i] = vm.urlQuery[i];
            }
            url_used = 1;
        }

        $scope.$watchCollection("vm.query",function (newValue, oldValue) {
            for ( var i in newValue ) {
                if ( i !== 'page' && newValue[i] !== oldValue[i]) {
                    vm.startSearch ++;
                    get_location_alerts();
                }
            }

        });

        $scope.$on('refresh_locationAlertsCtrl', function (event, data) {
            activate();
        });

        function activate() {
            var promises = [
                get_location_alerts()
            ];
            common.activateController(promises, controllerId)
                .then(function() {
                    //  log('Activated Order List View');
                });
        }

        function get_location_alerts() {

            vm.tableParams = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {

                    vm.query.page = params.page;
                    //vm.query.count = params.count;

                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }
                    // ajax request to api
                    return datacontext.get_product_location(vm.query).then(function (httpResult) {
                      params.total(httpResult.data.total);
                      vm.results_total = httpResult.data.total;
                      // set new data
                      vm.results = httpResult.data.data;
                      return httpResult.data.data;
                    });
                }
            });
        }

        // Push Location Product
        $scope.remove_location_product = function (data, idx) {



            var payload = {
                loc_prod_id:data.loc_prod_id,
                product_id:data.product_id,
                warehouse_id:data.warehouse_id
            };

            datacontext.delete_location_product(payload).then(function() {
                vm.results.splice(idx,1);
                vm.remove_message = 'LOCATION REMOVED: ' + data.location_name;
            });

        };
    }
})();

(function() {
    'use strict';
    var controllerId = 'locationPendingAuditCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$location', 'NgTableParams',  '$window', locationPendingAuditCtrl]);

    function locationPendingAuditCtrl(common, datacontext, $scope, $location, NgTableParams, $window) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;

        vm.location = [];
        vm.query = {
            order_by:"location_id",
            order_dir:"desc",
            location_type_id:"99",
            is_empty:1,
            page:1,
            limit:50
        };

        // selectively update
        vm.query = $location.search();
        vm.urlQuery  = $location.search();
        var url_used = 0;

        // loop and set url var
        for ( var i in vm.urlQuery ){
            if ( i !=='queryType') {
                vm.query[i] = vm.urlQuery[i];
            }
            url_used = 1;
        }

        $scope.$watchCollection("vm.query",function (newValue, oldValue) {
            for ( var i in newValue ) {
                if ( i !== 'page' && newValue[i] !== oldValue[i]) {
                    vm.startSearch ++;
                    get_location_audit();
                }
            }
        });

        $scope.$on('refresh_locationPendingAuditCtrl', function (event, data) {
            activateAudit();
        });

        function activateAudit() {
            var promises = [
                get_location_audit()
            ];
            common.activateController(promises, controllerId)
                .then(function() {
                    //  log('Activated Order List View');
                });
        }

        function get_location_audit() {

            vm.tableParams = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {

                    vm.query.page = params.page;
                    //vm.query.count = params.count;

                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];

                    }
                    if(!angular.isDefined(vm.query.location_type_id)) {
                      vm.query.location_type_id = '99';
                    }
                    // ajax request to api
                    return datacontext.get_product_audit_needed(vm.query).then(function (httpResult) {
                        params.total(httpResult.data.TOTAL);
                        vm.results_total = httpResult.data.TOTAL;
                        vm.remove_message = httpResult.data.TOTAL + " Items Found";
                        // set new data
                        vm.results = httpResult.data.data;
                        return httpResult.data.data;
                    });
                }
            });
        }

        // Push Location Product
        $scope.remove_location_product = function (data, idx) {



            /*var payload = {
                loc_prod_id:data.loc_prod_id,
                product_id:data.product_id
            };*/

            $location.path('/product/' + product_id);



        };

        $scope.remove_location_audit = function (location_id,location_name,product_id) {

        	var payload = {
        		location_id:location_id
            };
        	//location.href = '#/product/'+product_id;
        	window.open('#/product/'+product_id+'?toaudit=1','_blank');

        };
    }
})();

(function() {
    'use strict';
    var controllerId = 'locationCommonCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$location', 'NgTableParams', locationCommonCtrl]);

    function locationCommonCtrl(common, datacontext, $scope, $location, NgTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.locations = [];
        vm.title = 'Location List View';

        vm.query = {
            queryType:'array-count',
            search:'',
            order_by:"product_id",
            order_dir:"desc",
            page:1,
            limit:20
        };
        $scope.$on('refresh_locationCommonCtrl', function (event, data) {
        	activate();
        });

        function activate() {
            var promises = [get_common_locations()];
            common.activateController(promises, controllerId)
                .then(function() {
                   // log('Activated Location List View');
                });
        }
        function get_common_locations() {
         datacontext.get_common_locations().then(function (httpResult) {
           vm.common_location_count = httpResult.data.TOTAL;
           vm.results_com = httpResult.data.data;
          });
        }

    }
})();
